/**
 * @desc 获取详情-系统编号和标签
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(params: API.ucenter.sysNumStep.getInfo.Params, options?: any) {
  return updateResponse(
    http(URL + `/sysNumStep/info`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
